import * as React from 'react'
import { List, Tag, Typography, Space, Divider } from 'antd'

import {
  CheckOutlined,
  CloseOutlined,
  GlobalOutlined,
  ClockCircleOutlined,
  EyeInvisibleOutlined
} from '@ant-design/icons'

import ProfileTags from '../tags'
import ProfilePriority from '../priority'

const { Text } = Typography

const VendorInformation = (props) => {
  const { vendor, updatePriority, priorities, managerMode } = props

  return (
    <>
      {/* <div className="user-image m-b-20">
      <img />
      </div>
      */}
      <div className='personal-info'>
        <h2>{vendor.name}</h2>
        <h4 className='user-designation m-b-10'>{vendor.type}</h4>
        <h4 className='user-designation m-b-10'>
          <GlobalOutlined /> {vendor?.country?.name?.toUpperCase()}
        </h4>
        <h4 className='user-designation m-b-10'>
          <ClockCircleOutlined /> {vendor?.timezone}
        </h4>

        <Space direction='vertical'>
          <Tag color='default'>
            <Text>WORK WITH MT</Text>
            <Divider type='vertical' />
            {vendor.work_with_mt
              ? (
                <Text type='success'>
                  <CheckOutlined />
                </Text>
                )
              : (
                <Text type='danger'>
                  <CloseOutlined />
                </Text>
                )}
          </Tag>

          <Tag color='default'>
            <Text>WORK ON HOLIDAYS</Text>
            <Divider type='vertical' />
            {vendor.work_on_holidays
              ? (
                <Text type='success'>
                  <CheckOutlined />
                </Text>
                )
              : (
                <Text type='danger'>
                  <CloseOutlined />
                </Text>
                )}
          </Tag>

          {vendor.years_of_experience && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Experience' description={vendor.years_of_experience} />
            </List.Item>
          )}
        </Space>
      </div>
      <div className='contact-info'>
        <h2 className='after-underline'>Contact Information</h2>
        <div className='m-t-15 m-b-20'>
          {vendor.email && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='E-Mail' description={vendor.email} />
            </List.Item>
          )}
          {vendor.skype && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Skype' description={vendor.skype} />
            </List.Item>
          )}
          {vendor.phone && (
            <List.Item style={{ padding: '0px 0px' }}>
              <List.Item.Meta title='Phone' description={vendor.phone} />
            </List.Item>
          )}
        </div>
      </div>

      {managerMode && (
        <Divider plain>
          <EyeInvisibleOutlined /> Hidden
        </Divider>
      )}
      {managerMode && (
        <ProfilePriority
          vendor={vendor}
          updatePriority={updatePriority}
          priorities={priorities}
          id={vendor.id.toString()}
        />
      )}
      {managerMode && <ProfileTags id={vendor.id.toString()} />}
    </>
  )
}

export default VendorInformation
